import { render } from "./CltnSortFilterComp.vue?vue&type=template&id=2220f74c&ts=true"
import script from "./CltnSortFilterComp.vue?vue&type=script&lang=ts"
export * from "./CltnSortFilterComp.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__